var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"page-title":"Bill Definition","page-icon":"mdi-account-multiple-outline","collection-name":"billDefinition","items-per-page":20,"add-dialog-title":"Add Bill Definition","is-filter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }